module.exports = __webpack_public_path__ + "static/media/maite_harinadetrigo(1).565cefff.png";